import { Button } from 'component/Button'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ItemsLine } from 'page/CombineScreen/item/ItemsLine'
import { ItemsNone } from 'page/CombineScreen/item/ItemsNone'
import { Page } from 'page/Page/Page'
import { controller } from 'store/controller'
import { store } from 'store/store'
import { getShapeLabel } from 'type/Inference'

export const CombineScreen = observer(() => {
  const item = store.item
  if (!item) return null

  const { json } = item
  const { item_combo_image, item_full_image, dress_shape_type, product_name } = json
  const rec = item.rec
  const selectedItem = rec.item

  const mainImage = item_combo_image || item_full_image
  const mainShape = getShapeLabel(dress_shape_type)
  const mainName = product_name

  const comboShape = selectedItem ? getShapeLabel(selectedItem.dress_shape_type) : undefined
  const comboName = selectedItem?.product_name

  const onContinue = useLatestCallback(() => {
    void controller.generateRec()
  })

  return (
    <Page clear full>
      <Vertical tall wide oh pad={[0,16]} gap={16}>
        <Space round={6} oh parallel spring>
          {mainImage && <Image src={mainImage} contain />}
        </Space>

        <Space wide gap={4}>
          {mainShape && <Typo size={10} upper secondary>{mainShape}</Typo>}
          {mainName && <Typo secondary>{' • '}</Typo>}
          {mainName && <Typo size={10} upper medium one>{mainName}</Typo>}
        </Space>

        <Vertical flex="0 0 auto" oh>
          {!rec.line && <ItemsNone />}
          {rec.line && <ItemsLine />}
        </Vertical>

        <Space wide gap={4}>
          {comboShape && <Typo size={10} upper secondary>{comboShape}</Typo>}
          {comboName && <Typo secondary>{' • '}</Typo>}
          {comboName && <Typo size={10} upper medium one>{comboName}</Typo>}
        </Space>

        <Button large wide primary disabled={!selectedItem} action={onContinue}>
          {i18n('TryTogether')}
        </Button>
      </Vertical>
    </Page>
  )
})
